module.exports = __webpack_public_path__ + "img/trombi.83e96f37.png";